
function TotalLength(el){
    var path = document.querySelectorAll(el);
    for (let elem of path) {
        var len = Math.round(elem.getTotalLength() );
        elem.setAttribute("stroke-dasharray", len);
        elem.setAttribute("stroke-dashoffset", len);
        elem.classList.add('draw');
    }
};

window.addEventListener('DOMContentLoaded', function() {

    $('.challenges').on('click mouseover', '.block-number', function (e) {
        e.preventDefault();
        console.log('test');
        $('.challenges').find('.section-in__descr').removeClass('active');
        $('.challenges').find('.section-in__title').removeClass('active');
        $(this).next('.section-in__descr').addClass('active');
        $(this).next('.section-in__text').addClass('active');
    });

    function challengesAnimation(){
        $('.challenges').find(".blocks-wrap").addClass('before after');
        setTimeout(function() {
            $('.challenges').find('.point-1').css('transform','translate(-50%, -50%) scale(1)');
        }, 100);
        setTimeout(function() {
            $('.challenges').find('.point-2').css('transform','scale(1)');
        }, 200);
        setTimeout(function() {
            $('.challenges').find('.point-3').css('transform','scale(1)');
        }, 300);
        setTimeout(function() {
            $('.challenges').find('.point-4').css('transform','scale(1)');
        }, 400);
        setTimeout(function() {
            $('.challenges').find('.point-5').css('transform','translate(-40%, 0) scale(1)');
            $('.challenges').find('.section-in__descr, .section-img-wrap .text-block-subtitle').css('opacity','1');
            $('.challenges').find('.section-btn').css('opacity','1');
        }, 500);
    };
    challengesAnimation();

    function actuatorSectionAnimation(){
      if( $('.actuator').length)   { 
        $('.actuator').find('.text p').css('opacity','1');
      }
        TotalLength('.case-actuator-icon #Path');
        TotalLength('.case-actuator-icon #Oval');
        setTimeout(function() {
            $('.case-actuator-icon').find('.path-fill').addClass('full');
            $('.case-actuator-icon').find('.path-fill-dark').addClass('full');
        }, 2000);
      
    };

    if( $('.actuator').length)   { 
    var actuatorSection = $('.actuator').offset().top;
    var actuator_count = 0;
    var challengesSection = $('.challenges').offset().top;
    var challenges_count = 0;

    if($( window ).width() > 768 ){
        var offset = $('.header-wrapper').offset().top + 600;
    } else{
        var offset = $('.header-wrapper').offset().top + 450;
    }

    $(window).scroll(function(){

        if(actuatorSection - offset <= $(this).scrollTop() && actuator_count == 0) {
            actuator_count = 1;
            actuatorSectionAnimation();
        }
        if(challengesSection - offset <= $(this).scrollTop() && challenges_count == 0) {
            challenges_count = 1;
            challengesAnimation();
        }
    });
    }
});
